
import { defineComponent } from '@nuxtjs/composition-api';
import { CdnImg } from '@webplatform/cdn-image';

export default defineComponent({
  components: {
    CdnImg,
  },
  props: {
    image: {
      type: Object,
      default: () => {},
    },
    link: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: '',
    },
  },
});
